import { render, staticRenderFns } from "./CreateGeneTestForm.vue?vue&type=template&id=4dd75f89&scoped=true"
import script from "./CreateGeneTestForm.vue?vue&type=script&lang=js"
export * from "./CreateGeneTestForm.vue?vue&type=script&lang=js"
import style0 from "./CreateGeneTestForm.vue?vue&type=style&index=0&id=4dd75f89&prod&lang=scss&scoped=true"
import style1 from "./CreateGeneTestForm.vue?vue&type=style&index=1&id=4dd75f89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd75f89",
  null
  
)

export default component.exports